import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pr-acc-test-chip',
  imports: [],
  templateUrl: './acc-test-chip.component.html',
  styleUrl: './acc-test-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccTestChipComponent {}
